// The four kids subcategories (ids 7-10) are stored with a "-KIDS" suffix on every name_* column so
// they stay distinguishable from their adult twins ("Чаршафи" vs "Чаршафи-KIDS") wherever the rows
// are read without their parent category. That suffix is bookkeeping, not shop copy, so it never
// reaches the page: it becomes a "Детски" prefix instead ("Детски Чаршафи"). The slugs keep their
// "-kids" ending; the URLs are unchanged.
const KIDS_SUFFIX = /\s*-\s*KIDS\s*$/i;
const KIDS_PREFIX = 'Детски';

export const subCategoryDisplayName = (name) => {
  if (!name) return name;
  if (!KIDS_SUFFIX.test(name)) return name;
  return `${KIDS_PREFIX} ${name.replace(KIDS_SUFFIX, '')}`;
};

// Singular product-type labels for the related-products chips. A chip tags one item
// ("Чаршаф"), so it reads singular, where the nav and the category tiles name the
// collection ("Чаршафи").
//
// Keyed by subCategory id - that is the product kind, and it is what /linkedProducts
// already returns. NOT productTypeAttributeId, which encodes the print (solid /
// pattern / round). Bulgarian only, like the rest of the category copy.
const SUB_CATEGORY_SINGULAR = {
  1: 'Чаршаф',
  2: 'Калъфка',
  3: 'Чаршаф с ластик',
  4: 'Плик',
  6: 'Кръгъл чаршаф с ластик',
  7: 'Детски чаршаф',
  8: 'Детска калъфка',
  9: 'Детски чаршаф с ластик',
  10: 'Детски плик'
};

export const productTypeLabel = (subCategoryId) => SUB_CATEGORY_SINGULAR[subCategoryId];
